import { useLocalStore } from 'mobx-react-lite';

import { ICommonPopupsProps } from '@gem/popups';

import { storage } from 'APP/packages/storage';

interface IE2eeDisclaimerPopupPresenter {
  onClose(): void;
  onBack(): void;
}

export function useE2eeDisclaimerPopupPresenter({
  popupInstance,
  onClose,
  onBack,
}: ICommonPopupsProps): IE2eeDisclaimerPopupPresenter {
  const presenter = useLocalStore<IE2eeDisclaimerPopupPresenter>(() => ({
    onClose(): void {
      popupInstance.close();
      onClose?.();
      storage.secretChatOnboarding.set(true);
    },

    onBack(): void {
      popupInstance.close();
      onBack?.();
    },
  }));

  return presenter;
}
